import { render, staticRenderFns } from "./selectMetadata.vue?vue&type=template&id=6483c162&scoped=true&"
import script from "./selectMetadata.vue?vue&type=script&lang=js&"
export * from "./selectMetadata.vue?vue&type=script&lang=js&"
import style0 from "./selectMetadata.vue?vue&type=style&index=0&id=6483c162&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6483c162",
  null
  
)

export default component.exports